import { Form } from '@themesberg/react-bootstrap'
import React from 'react'
import { useResponsive } from '../hooks/useResponsive'

function SelectInput(props) {
  const { 
    options = [], 
    label = null, 
    labelClass, 
    size, 
    required = false,
    error = '',
    isInvalid = false
  } = props
  
  const { isMobile } = useResponsive();
  
  return (
    <Form.Group className={isMobile ? 'form-mobile' : ''}>
      {label && (
        <Form.Label className={`${labelClass} ${required ? 'required' : ''}`}>
          {label}
          {required && <span className="text-danger ms-1">*</span>}
        </Form.Label>
      )}
      <Form.Select
        defaultValue={props.defaultValue || '0'}
        {...props}
        size={isMobile ? 'lg' : (size || 'sm')}
        isInvalid={isInvalid}
        style={{
          minHeight: isMobile ? '48px' : 'auto',
          fontSize: isMobile ? '16px' : '14px',
          borderWidth: isMobile ? '2px' : '1px'
        }}
      >
        <option value="">--Select--</option>
        {options.map((o, i) => (
          <option key={i} value={o}>
            {o}
          </option>
        ))}
      </Form.Select>
      {error && (
        <Form.Control.Feedback type="invalid" className="d-block">
          {error}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  )
}

export default SelectInput
